<template>
  <IconLucidePencilLine />
</template>
